import { render, staticRenderFns } from "./v-prg-field.vue?vue&type=template&id=11a638af&scoped=true&"
import script from "./v-prg-field.vue?vue&type=script&lang=js&"
export * from "./v-prg-field.vue?vue&type=script&lang=js&"
import style0 from "./v-prg-field.vue?vue&type=style&index=0&id=11a638af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a638af",
  null
  
)

export default component.exports